import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const DownArrowIcon = ({ className, onClick }: Props) => {
  return (
    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 56 64" fill="none">
      <path d="M28 44.9258L28 6.00578" stroke="white" stroke-width="10.4348" stroke-linecap="square" stroke-linejoin="bevel"/>
      <path d="M48 34.2734L28 55.6102L8 34.2734" stroke="white" stroke-width="10.4348" stroke-linecap="square"/>
    </svg>
  );
};

export default DownArrowIcon;
